module.exports = __webpack_public_path__ + "static/media/messages.7ec13ccb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/guide/messages.svg
// module id = 580
// module chunks = 0